import { useState } from "react";
import { SectionBasedProduct } from "@brandclub/common-ui";
import { ConversationMessage, ProductPreview } from "../types/conversation";

export const useConversationState = () => {
  const [conversationId, setConversationId] = useState<string | null>(() => {
    const params = new URLSearchParams(window.location.search);
    return params.get("conversationId") || null;
  });

  const [followUpQuestions, setFollowUpQuestions] = useState<string[]>([]);

  const [conversationHistory, setConversationHistory] = useState<
    ConversationMessage[]
  >([]);

  const [isActivelyStreaming, setIsActivelyStreaming] = useState(false);
  const [streamingAIResponse, setStreamingAIResponse] = useState("");
  const [currentStatus, setCurrentStatus] = useState<string>("");

  const [previewSearchQueries, setPreviewSearchQueries] = useState<string[]>(
    []
  );
  const [previewQueryProducts, setPreviewQueryProducts] = useState<
    Array<{ query: string; queryIndex: number; products: ProductPreview[]; totalResults: number }>
  >([]);
  const [isWaitingForFollowUpQueries, setIsWaitingForFollowUpQueries] =
    useState(false);

  // Centralized product metadata storage - maps stacklineSku to full product metadata
  const [productMetadataMap, setProductMetadataMap] = useState<
    Map<string, SectionBasedProduct>
  >(new Map());

  // Store product group SKUs for streaming (maps group index to array of SKUs)
  const [streamingProductGroups, setStreamingProductGroups] = useState<
    Map<number, string[]>
  >(new Map());

  // Store featured product being streamed (shown above user message during streaming)
  const [streamingFeaturedProduct, setStreamingFeaturedProduct] = useState<{
    product: SectionBasedProduct;
    question: string;
  } | null>(null);

  return {
    conversationId,
    setConversationId,
    conversationHistory,
    setConversationHistory,
    isActivelyStreaming,
    setIsActivelyStreaming,
    streamingAIResponse,
    setStreamingAIResponse,
    currentStatus,
    setCurrentStatus,
    previewSearchQueries,
    setPreviewSearchQueries,
    previewQueryProducts,
    setPreviewQueryProducts,
    isWaitingForFollowUpQueries,
    setIsWaitingForFollowUpQueries,
    productMetadataMap,
    setProductMetadataMap,
    streamingProductGroups,
    setStreamingProductGroups,
    followUpQuestions,
    setFollowUpQuestions,
    streamingFeaturedProduct,
    setStreamingFeaturedProduct,
  };
};
